import { Action, createReducer, on } from '@ngrx/store';
import { BadResponseWithError } from '../../models/bad-response-with-error.interface';
import { UploadMediaActions } from '../actions/actions-type.action';

export interface MediaState {
    isLoading: boolean;
    error: BadResponseWithError | null;
}

const initialState: MediaState = {
    isLoading: false,
    error: null,
};

const reducer = createReducer(
    initialState,
    on(UploadMediaActions.uploadImageFile, (state, action) => ({
        ...state,
        isLoading: true,
    })),
    on(UploadMediaActions.uploadImageFileSuccess, (state, action) => ({
        ...state,
        isLoading: false,
    })),
    on(UploadMediaActions.uploadImageFileFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: action.payload,
    }))
);

export const mediaReducer = (state: MediaState, action: Action) =>
    reducer(state, action);
